import React, { Component} from 'react'
import { connect } from 'react-redux'
import { isFetching } from 'utils/redux/fetching'
import { reduxForm, formValueSelector } from 'redux-form'
import MobileCurrencyList from 'components/MobileCurrencyList'
import { fetchCurrencies } from 'redux/actions/currencies'
import { fetchRates } from 'redux/actions/rates'
import { fetchCryptoCurrencies } from 'redux/actions/cryptoCurrencies'
import { fetchCryptoRates } from 'redux/actions/cryptoRates'
import { fetchRatesHistory } from 'redux/actions/ratesHistory'
import { fetchCryptoRatesHistory } from 'redux/actions/cryptoRatesHistory'
import Loader from 'components/Loader'
import { buildInitials } from 'utils/redux/helpers'
import moment from 'moment'

class MobileCurrencyListContainer extends Component {
	componentWillMount () {
		const { dispatch, mode } = this.props
		if (mode === 'monetary') {
			dispatch(fetchCurrencies())
			dispatch(fetchRates())
		}
		else {
			dispatch(fetchCryptoCurrencies())
			dispatch(fetchCryptoRates())
		}
	}
	render () {
		if(this.props.isFetching) return <Loader />
		return <MobileCurrencyList {...this.props} />
	}
}

const mapStateToProps = (state, props) => {
	const { currencies, rates, cryptoCurrencies, cryptoRates } = state
	const { mode } = props

	if (mode === 'monetary' && isFetching([currencies, rates])) return { isFetching: true }
	if (mode === 'crypto' && isFetching([cryptoCurrencies, cryptoRates])) return { isFetching: true }

	const selector = formValueSelector('mobileCurrencyList')
	const values = selector(state, 'currency')

	let currenciesList = [...currencies.data, {
		id: 999,
		name: 'Български лев',
		abbreviature: 'BGN',
		flag: '/flags/bgn.png'
	}]

	return {
		currencies: mode === 'monetary' ? currenciesList : cryptoCurrencies.data,
		selectedCurrencyRate: values
			? (mode === 'monetary' ? rates.data.find( r =>  r.to_currency_id === values.value) : cryptoRates.data.find(r =>  r.to_crypto_currency_id === values.value))
			: null,
		initialValues: mode === 'monetary'
			? { currency: buildInitials(currenciesList, 'AUD') }
			: { currency: buildInitials(cryptoCurrencies.data, 'BTC') }
	}
}

const mapDispatchToProps = (dispatch, props) => {
	return {
		onChange: selected => {
			const { mode } = props
			const fromDate = moment().subtract(7,'d').format('YYYY-MM-DD')
			const selectedValue = selected.currency.value

			if (mode === 'monetary') {
				dispatch(fetchRatesHistory({
					from_date: fromDate,
					to_currency_id: selectedValue,
				}, true))
			}
			else {
				dispatch(fetchCryptoRatesHistory({
					from_date: fromDate,
					to_crypto_currency_id: selectedValue,
				}, true))
			}
		}

	}
}

export default connect(mapStateToProps, mapDispatchToProps)(reduxForm({ form: 'mobileCurrencyList' })(MobileCurrencyListContainer))
